import React, { useEffect, useState } from 'react'
import { Button, Table, Typography, Space, Image, Flex, Form, Row, Col } from 'antd'
import { notiData } from '../../../Data';
import { ActionButton, AlertModal, SearchInput } from '../..';
import { useNavigate } from 'react-router-dom';
import { actionsApi, TableLoader } from '../../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { apiCalls } from '../../../shared/Apis';

let timer;
const { Text, Paragraph } = Typography;
const NotificationTable = () => {

    const navigate = useNavigate()
    const [deleteitem,setDeleteItem] = useState(false)
    const [ deletionLoading, setDeletionLoading]= useState(false)
    const dispatch = useDispatch()
    const [form] = Form.useForm();
    const { notifData, loadingnotif, filters, pagination } = useSelector(state => state?.Notigetapi)

    useEffect(()=>{
        dispatch(actionsApi?.getNotificationsAll({...filters, ...pagination, pageNo: 1}))
    },[])

    const call = (pageNo=1, pageSize=10)=> {
        dispatch(actionsApi?.getNotificationsAll({...filters, pageNo, pageSize}))
    }

     function searchHandler(name, pageNo=1, pageSize=20) {
        dispatch(actionsApi?.getNotificationsAll({ ...filters, name, pageNo, pageSize }))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(searchHandler, 400)

    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Title</Text>,
            dataIndex: 'title',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Description</Text>,
            dataIndex: 'description',
            render: (_,row) => <Paragraph ellipsis={{rows: 1}}>{row?.description}</Paragraph>
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 150,
            render: (_, row) => (
                <Space>
                    <ActionButton
                        title='Notification View'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {navigate(`/notification/detail/${row?.id}`)}}
                    />
                    <ActionButton
                        title='Delete Item'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.title, id:row?.id})}}
                    />
                </Space>
            ),
        },
    ];

    // delete job api
    const DeleteNotifciation= async ()=>{
        setDeletionLoading(true)
        let result= await apiCalls?.Notificationpostapi?.DeleteNotifciation(deleteitem?.id)
        if(result){
            setDeleteItem(null)
            searchHandler('')
        }
        setDeletionLoading(false)
    }
    return (
        <>
        <Flex vertical gap={20}>
            <Form
                form={form}
                layout="vertical"
            >
                <Row gutter={[16,16]} align={'middle'}>
                    <Col lg={8} md={12} sm={24} xs={24}>
                        <SearchInput 
                            name='name'
                            placeholder='Search'
                            value={form.getFieldValue('name') || ''}
                            prefix={<img src='/assets/icons/search.png' width={20} />}
                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                            onChange={(e)=> debouncedSearchHandler(e.target.value, 1,20)}
                        />
                    </Col>
                </Row>
            </Form>
            <Table
                size='large'
                columns={columns}
                dataSource={notifData}
                className='pagination'
                showSorterTooltip={false}
                scroll={{ x: 1200 }}
                pagination={{
                    hideOnSinglePage: true,
                    total: pagination?.totalRecords,
                    pageSize: pagination?.pageSize,
                    defaultPageSize: pagination?.pageSize,
                    current: pagination?.pageNo,
                    size: "default",
                    pageSizeOptions: ['10', '20', '50', '100'],
                    onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                    showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                }}
                loading = {
                    {
                        ...TableLoader,
                        spinning: loadingnotif
                    }
                }
            />
        </Flex>
            <AlertModal
                visible={deleteitem}
                deleteitem={deleteitem}
                callBack={DeleteNotifciation}
                deletionLoading={deletionLoading}
                onClose={()=>{setDeleteItem(false)}}
            />
        </>
    )
}

export { NotificationTable }